import {createAction, props} from '@ngrx/store';
import {
  EmbeddingAugmentorResultDTO,
  EmbeddingDTO,
  PaperHasEmbeddingDTO,
  ProjectHasEmbeddingOverviewDTO
} from '../dto/embedding';
import {PaperChatFilterType} from '../dto/paper-chat';


export const checkAndCreatePaperEmbedding = createAction(
  '[Embeddings] Check and Create Embedding',
  props<{ paperId: number }>()
);

export const checkAndCreatePaperEmbeddingSuccess = createAction(
  '[Embeddings] Check and Create Embedding Success',
  props<{ hasEmbedding: boolean, paperId: number }>()
);

export const checkAndCreatePaperEmbeddingFailure = createAction(
  '[Embeddings] Check and Create Embedding Failure',
  props<{ error: any,  paperId: number }>()
);

export const loadEmbeddingsForProject = createAction(
  '[Embeddings] Load Embeddings For Project',
  props<{ projectId: number }>()
);

export const loadEmbeddingsForProjectSuccess = createAction(
  '[Embeddings] Load Embeddings For Project Success',
  props<{ projectId: number, embeddings: EmbeddingDTO[] }>()
);

export const loadEmbeddingsForProjectFailure = createAction(
  '[Embeddings] Load Embeddings For Project Failure',
  props<{ error: any }>()
);

export const loadProjectHasEmbeddingOverview = createAction(
  '[Embeddings] Load Has All Paper Embedding overview',
  props<{ projectId: number }>()
);

export const loadProjectHasEmbeddingOverviewSuccess = createAction(
  '[Embeddings] Load Embeddings For Project overview Success',
  props<{ projectId: number, result: ProjectHasEmbeddingOverviewDTO }>()
);

export const loadProjectHasEmbeddingOverviewFailure = createAction(
  '[Embeddings] Load Embeddings For Project overview Failure',
  props<{ error: any }>()
);

export const loadHasAllPaperEmbedding = createAction(
  '[Embeddings] Load Has All Paper Embedding',
  props<{ projectId: number; filter?: PaperChatFilterType }>()
);

export const loadHasAllPaperEmbeddingSuccess = createAction(
  '[Embeddings] Load Has All Paper Embedding Success',
  props<{ projectId: number, paperHasEmbeddings: PaperHasEmbeddingDTO[] }>()
);

export const loadHasAllPaperEmbeddingFailure = createAction(
  '[Embeddings] Load Has All Paper Embedding Failure',
  props<{ error: any }>()
);

export const loadEmbeddingsForPaper = createAction(
  '[Embeddings] Load Embeddings For Paper',
  props<{ paperId: number }>()
);

export const loadEmbeddingsForPaperSuccess = createAction(
  '[Embeddings] Load Embeddings For Paper Success',
  props<{ embeddings: EmbeddingDTO[], paperId: number }>()
);

export const loadEmbeddingsForPaperFailure = createAction(
  '[Embeddings] Load Embeddings For Paper Failure',
  props<{ error: any }>()
);

export const loadEmbeddingAugmentorResult = createAction(
  '[Embeddings] Load Embedding Augmentor Result',
  props<{ projectId: number; query: string }>()
);

export const loadEmbeddingAugmentorResultSuccess = createAction(
  '[Embeddings] Load Embedding Augmentor Result Success',
  props<{ results: EmbeddingAugmentorResultDTO[] }>()
);

export const loadEmbeddingAugmentorResultFailure = createAction(
  '[Embeddings] Load Embedding Augmentor Result Failure',
  props<{ error: any }>()
);


export const deleteEmbeddingsForUser = createAction(
  '[Embeddings] delete Embeddings For User'
);

export const deleteEmbeddingsForUserSuccess = createAction(
  '[Embeddings] delete Embeddings For User Success'
);

export const deleteEmbeddingsForUserFailure = createAction(
  '[Embeddings] delete Embeddings For User Failure',
  props<{ error: any }>()
);
